import { t } from 'i18next';

export enum OperationContext {
  TLS = 'TLS',
  NON_TLS = 'NON_TLS',
}

export const getOperationContextLabel = (context: OperationContext): string => {
  return t(`operationProperties.contexts.${context}`);
};
